class AnimatedTimeline extends HTMLElement {
    constructor() {
      super();
      this.scroller = this.querySelector('.animated-timeline__content');
      this.currentScroll = 0;
      this.scrollIndicators = this.querySelectorAll('[data-scroll-index]');
      this.observer = null;
    }
  
    connectedCallback() {
  
      window.addEventListener('scroll', this.updateScroll, { passive: true });
      window.addEventListener('resize', this.updateScroll);
  
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.updateScroll();
          }
        });
      });
  
      this.observer.observe(this);
      this.updateScroll();
    }
  
    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateScroll);
      window.removeEventListener('resize', this.updateScroll);
  
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

  
    updateScroll = () => {
      const rect = this.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
  
      const total = viewportHeight + rect.height;
      const passed = viewportHeight - rect.top;
  
      let scrollPercent = (passed / total) * 100;
      scrollPercent = Math.max(0, Math.min(100, scrollPercent));
  
      this.currentScroll = scrollPercent;
  
      this.scrollIndicators.forEach((indicator) => {
        const scrollIndex = Number(indicator.dataset.scrollIndex);
  
        if (!Number.isNaN(scrollIndex) && scrollPercent >= scrollIndex) {
          indicator.classList.add('active');
        }
      });
    };
  }
  
  customElements.define('animated-timeline', AnimatedTimeline);